import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MENU } from 'src/app/layouts/sidebar/menu';
import { HttpService } from 'src/app/shared/http.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})

/**
 * PAges-404 component
 */
export class NotFoundComponent implements OnInit {
  ordering: any = [];
  menu: any = [];
  permissions: any;
  constructor(
    private httpService: HttpService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    let that = this;

    var count = 0;
    let menus = that.httpService.menus();
    let filteredMenus = menus.filter(x => x.AccessTypeId != null);
    that.permissions = filteredMenus.map(x => x.Id);
    for (var i = 0; i < MENU.length; i++) {
      if (MENU[i].link == '') {
        for (var j = 0; j < MENU[i].permissions.length; j++) {
          that.ordering[count] = MENU[i].permissions[j];
          that.menu.push(MENU[i].subItems[j]);
          count++;
        }
      }
      else {
        that.ordering[count] = MENU[i].permissions[0];
        that.menu.push(MENU[i]);
        count++;
      }
    }
  }

  back() {
    let that = this;
    let activemenu: any;
    for (var i = 0; i < that.ordering.length; i++) {
      let activePermission = that.permissions.find((x: any) => x == that.ordering[i]);
      if (activePermission != undefined) {
        activemenu = that.menu.find((m: { permissions: any[]; }) => m.permissions[0] == activePermission);
        if (activemenu) {
          break;
        }
      }
    }
    if (activemenu) {
      that.router.navigate([activemenu.link]);
    }
    else {
      that.router.navigate(['/profile']);
    }
  }

}
